import Checkout from './checkout.webp';
import Effects from './effects.webp';
import Landing from './landing.webp';
import Mobs from './mobs.webp';
import Store from './store.webp';

export default {
    Checkout,
    Effects,
    Landing,
    Mobs,
    Store
}